// Who "I" am in a record I own (multi-tenant step 6).
//
// A person with an email address is identified exactly as before: userEmail on
// the record, and their timesheet weeks named "{email local part}_{week}".
// Someone who signed in with only a phone number has no email, so their records
// carry ownerUid and their weeks are "{uid}_{week}" — firestore.rules ownsNew /
// ownsExisting / ownsSheetId accept either. ownerUid is NOT added for email
// users: several update rules allow only named fields, and ASP's writes must not
// change shape.
export const sheetKey = (session) => (session && session.email ? String(session.email).split('@')[0] : String((session && session.uid) || ''));
export const ownerFields = (session) => (session && !session.email && session.uid ? { ownerUid: session.uid } : {});

/** Is this timesheet week mine? An email user's sheet carries their userEmail, as
 *  before. A phone-only member has no email, so theirs is matched by ownerUid or
 *  by its id ("{uid}_{week}") — never by an empty userEmail, which every other
 *  phone-only member's sheet also has. */
export function ownsSheet(sheet, session) {
  if (!sheet || !session) return false;
  if (session.email) return sheet.userEmail === session.email;
  const uid = session.uid ? String(session.uid) : '';
  if (!uid) return false;
  return sheet.ownerUid === uid || String(sheet.id || '').startsWith(`${uid}_`);
}

/** The filter that lists only my own records (expenses, leave): userEmail for an
 *  email user, ownerUid for a phone-only member. */
export const ownerFilter = (session) => (session && session.email ? { userEmail: session.email } : { ownerUid: (session && session.uid) || '__none__' });
